export const privacy = {
  "header": {
    "badge": "Persoonlijke gegevens",
    "title": "Privacybeleid"
  },
  "content": {
    "intro": "De bescherming van uw privacy en persoonsgegevens is een absolute prioriteit voor DONKEY TRAVEL. Dit beleid beschrijft hoe wij uw gegevens verzamelen, verwerken en beveiligen.",
    "collection": {
      "title": "1. Gegevensverzameling",
      "text": "We verzamelen alleen de gegevens die strikt noodzakelijk zijn voor de goede werking van het platform: de informatie over het aanmaken van uw account (achternaam, voornaam, e-mail), links naar uw openbare aankondigingen (Airbnb) en uw reisvoorkeuren en beschikbaarheid. Wachtwoorden worden gecodeerd en betalingsgegevens worden verwerkt door onze beveiligde partner Stripe."
    },
    "usage": {
      "title": "2. Gebruik van uw gegevens",
      "text": "Uw gegevens worden gebruikt om: \n- Controleer of u in aanmerking komt (beoordeling 4,5+) \n- Beheer uw abonnement \n- Faciliteren van verbinding met andere leden \n- Geef gepersonaliseerde aanbevelingen via onze Intelligent Matching \n- Verbeter onze dienstverlening en los technische problemen op."
    },
    "sharing": {
      "title": "3. Informatie delen",
      "text": "Wij zullen uw persoonlijke gegevens NOOIT aan derden verkopen. Het delen ervan is strikt beperkt tot operationele doeleinden met onze vertrouwde dienstverleners (webhosting, betalingstool). Buiten dit kader worden uw gegevens alleen gedeeld tussen leden voor de organisatie van een uitwisseling (en alleen het exacte adres na validatie van een uitwisseling)."
    },
    "security": {
      "title": "4. Beveiliging",
      "text": "De meest robuuste authenticatie- en beveiligingsprotocollen zijn aanwezig om uw gegevens te beschermen tegen ongeoorloofde toegang, wijziging, openbaarmaking of vernietiging."
    },
    "rights": {
      "title": "5. Jouw rechten (AVG)",
      "text": "In overeenstemming met de Algemene Verordening Gegevensbescherming heeft u op elk moment het recht om uw persoonsgegevens in te zien, te corrigeren, over te dragen of te verwijderen. U kunt dit recht uitoefenen via uw accountinstellingen of door ons te schrijven op dpo@donkey.travel."
    },
    "cookies": {
      "title": "6. Koekjes",
      "text": "We gebruiken essentiële cookies om uw inlogsessie te behouden, evenals anonieme analytische cookies om te begrijpen hoe onze site wordt gebruikt en uw ervaring te verbeteren."
    }
  }
};
